import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Branches } from 'src/app/Models/branch';
import { ApiService } from 'src/app/Service/api.service';


@Component({
  selector: 'app-branche',
  templateUrl: './branche.component.html',
  styleUrls: ['./branche.component.css']
})
export class BrancheComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: Branches;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Branches form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.NAME == undefined ||this.data.NAME =="") {
      this.message.error("Please Enter Name", "");
      isOk = false
    }
    if (this.data.MANAGER_NAME == undefined ||this.data.MANAGER_NAME =="") {
      this.message.error("Please Enter Manager Name", "");
      isOk = false
    }
    if (this.data.POST == undefined ||this.data.POST =="") {
      this.message.error("Please Enter Post", "");
      isOk = false
    }
    if (this.data.ADDRESS == undefined ||this.data.ADDRESS =="") {
      this.message.error("Please Enter Address", "");
      isOk = false
    }
    if (this.data.PHONE_NO == undefined ||this.data.PHONE_NO =="") {
      this.message.error("Please Enter Phone No", "");
      isOk = false
    }
 
    if(isOk)
    {

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateBranches(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Branches information updated Successfully...", "");

	this.logtext = 'Update & Close - Branches form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Branches ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Branches form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Branches ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update branches information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createBranches(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Branches information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	// this.logtext = 'Save & Close - Branches form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Branches ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Branches();
	this.logtext = 'Save & New - Branches form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Branches ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add branches information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Branches form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Branches ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}